import 'core-js/es6/string'
import 'core-js/es6/array'
import 'core-js/es6/map'
import 'core-js/es6/set'
import 'core-js/es6/object'
import 'core-js/es6/promise'
import 'core-js/es7/promise' // Promise.prototype.finally: o polyfill do es6 substitui o Promise nativo e não tem finally
import 'core-js/es7/object'
import 'core-js/es7/array'
import 'raf/polyfill'
import './config/axios.config'
import 'semantic-ui-css/semantic.min.css'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './i18n'

import { Provider } from 'mobx-react'
import { PostHogProvider } from 'posthog-js/react'
import stores from './stores'

require('dotenv').config()

window._____APP_STATE_____ = stores

ReactDOM.render(
  <PostHogProvider
    apiKey={'phc_GjCpGO2KjJfkfZOclV4P60jWvKlABWNApgiqkm51Qqy'}
    options={{
      api_host: 'https://us.i.posthog.com',
      capture_exceptions: true, // This enables capturing exceptions using Error Tracking
      debug: false,
    }}
  >
    <Provider rootStore={stores}>
      <App />
    </Provider>
  </PostHogProvider>,
  document.getElementById('app')
)
